<template>
  <div>
    <b-col sm="12">
      <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
               :items="summarys" :fields="fields">
        <template slot="storageFee">
          <label>{{formatPrice(getStorageFee())}}</label>
        </template>
        <template slot="inspectionAndCleaningFee">
          <label>{{formatPrice(getCleaningFee())}}</label>
        </template>
        <template slot="disposalFee">
          <label>{{formatPrice(getDiscardCharge())}}</label>
        </template>
      </b-table>
    </b-col>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    items: { default: [] }
  },
  data() {
    return {
      summarys: [{storageFee: '0', cleaningFee: '0', discardCharge: '0'}],
      fields: [
        { key: 'storageFee', label: this.$i18n.t('returnedAndStorage.table.storageFee'), variant: 'warning', class: 'text-right' },
        { key: 'inspectionAndCleaningFee', label: this.$i18n.t('returnedAndStorage.table.cleaningFee'), variant: 'warning', class: 'text-right' },
        { key: 'disposalFee', label: this.$i18n.t('returnedAndStorage.table.discardCharge'), variant: 'warning', class: 'text-right' },
      ],
    };
  },
  methods: {
    getStorageFee() { return this.items.reduce( (a, v) => a += utility.toNumber(v['storageFee']), 0); },
    getCleaningFee() { return this.items.reduce( (a, v) => a += utility.toNumber(v['inspectionAndCleaningFee']), 0); },
    getDiscardCharge() { return this.items.reduce( (a, v) => a += utility.toNumber(v['disposalFee']), 0); },
  },
};
</script>
